import postedAssetCalendar from './posted/PostedAssetCalendar';

Vue.component('inventory-posted', {
    props: ['categories'],
    components: { postedAssetCalendar },
});
